<script>
  export let size = 18;

  export let title = undefined;

  $: labelled = $$props["aria-label"] || $$props["aria-labelledby"] || title;
  $: attributes = {
    "aria-hidden": labelled ? undefined : true,
    role: labelled ? "img" : undefined,
    focusable: Number($$props["tabindex"]) === 0 ? true : undefined,
  };
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 18 16"
  fill="currentColor"
  preserveAspectRatio="xMidYMid meet"
  width="{size}"
  height="{Math.round((16 / 18) * size)}"
  {...attributes}
  {...$$restProps}
>
  {#if title}<title>{title}</title>{/if}
  <path
    d="M0.25 15.6996L9 0.599609L17.75 15.6996H0.25ZM1.45 14.9996H16.55L9 1.99961L1.45 14.9996ZM9 13.4996C9.14167 13.4996 9.26042 13.4517 9.35625 13.3559C9.45208 13.26 9.5 13.1413 9.5 12.9996C9.5 12.8579 9.45208 12.7392 9.35625 12.6434C9.26042 12.5475 9.14167 12.4996 9 12.4996C8.85833 12.4996 8.73958 12.5475 8.64375 12.6434C8.54792 12.7392 8.5 12.8579 8.5 12.9996C8.5 13.1413 8.54792 13.26 8.64375 13.3559C8.73958 13.4517 8.85833 13.4996 9 13.4996ZM8.65 11.4996H9.35V6.49961H8.65V11.4996Z"
  />
</svg>
